<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-28 10:31:17
 * @LastEditors: shenlin
 * @LastEditTime: 2022-10-10 11:28:15
-->
<template>
  <div class="container">
    <div class="container_title">兑现详情</div>
    <div class="container_content">
      <div class="voucher">
        <div class="voucher_left">
          <span>服务凭证</span>
          注：服务凭证内容如签约服务合同协议、发票信息等
        </div>
        <div
          :class="[
            'voucher_right',
            detailsList.auditStatus === 2
              ? 'histoy-colors'
              : detailsList.auditStatus === 3
              ? 'histoy-color'
              : ''
          ]"
        >
          {{ detailsList.auditStatus | audStatus }}
        </div>
      </div>

      <div class="details-fill" v-if="isFill">
        <el-form
          :model="dynamicValidateForm"
          ref="dynamicValidateForm"
          label-width="120px"
          class="demo-dynamic"
        >
          <el-form-item
            prop="contractServiceStartStr"
            :rules="[
              { required: true, message: '请选择时间', trigger: 'change' }
            ]"
            label="合同服务时间："
          >
            <el-date-picker
              v-model="enterpriseTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="getPoss"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="附件："
            class="author"
            prop="fileList"
            :rules="[
              { required: true, message: '请选择上传文件', trigger: 'change' }
            ]"
          >
            <el-upload
              ref="uploader"
              :action="fileUpload"
              :before-upload="beforeAvatarUpload"
              :on-remove="handleRemove1"
              :on-progress="handleProgress"
              multiple
              accept=".zip, .rar, .doc, .docx, .pdf, .xls, .xlsx, .png, .jpg"
              :headers="uploadHeader"
              :limit="10"
              :file-list="dynamicValidateForm.fileList"
              :on-success="docSuccess1"
              :on-exceed="handleExceed"
            >
              <el-button icon="el-icon-upload2">上传文件</el-button>
              <div slot="tip" class="el-upload__tip">
                支持扩展名：.zip .rar .doc .docx .pdf .xls .xlsx .png
                .jpg,文件大小不超过50M，最多上传10个
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item style="text-align: right">
            <el-button
              :disabled="isDisabled"
              type="primary"
              @click="apply('dynamicValidateForm')"
              >{{ applyText }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="details-computed" v-else>
        <div class="contract">
          <span>合同服务时间：</span>
          {{ detailsList.contractServiceStartStr }} 至
          {{ detailsList.contractServiceEndStr }}
        </div>
        <div class="file_list">
          <span>附件：</span>
          <div class="file_box">
            <span
              v-if="
                detailsList.attachmentList &&
                detailsList.attachmentList.length <= 0
              "
            >
              -
            </span>
            <div
              v-else
              v-for="(item, index) in detailsList.attachmentList"
              :key="index"
            >
              <img
                :src="item.ossUrl"
                v-if="getUrlType(item.ossUrl)"
                alt=""
                @click="onShow(item.ossUrl)"
              />
              <span v-else @click="download(item.ossUrl)" class="file"
                ><i class="el-icon-tickets"></i>{{ item.fileName }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container_title" v-if="isExamine">取消订单审核</div>
    <el-form
      :model="validateForm"
      ref="numberValidateForm"
      label-width="67px"
      class="demo-ruleForm"
      v-if="isExamine"
    >
      <el-form-item
        label="审核："
        prop="cancelStatus"
        :rules="[{ required: true, message: '请输入备注' }]"
      >
        <el-radio-group v-model="validateForm.cancelStatus" @change="adopt">
          <el-radio :label="2">通过</el-radio>
          <el-radio :label="3">驳回</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="备注："
        prop="cancelRemark"
        :rules="[{ required: isRequired, message: '请输入备注' }]"
      >
        <el-input
          type="textarea"
          placeholder="请输入内容"
          v-model="validateForm.cancelRemark"
          maxlength="200"
          show-word-limit
          :rows="6"
          style="width: 650px"
        >
        </el-input>
      </el-form-item>
    </el-form>

    <div class="details_right">
      <div class="histoy">兑现审核记录</div>
      <el-timeline
        v-if="
          detailsList.goodsOrderRecordList &&
          detailsList.goodsOrderRecordList.length > 0
        "
      >
        <el-timeline-item
          v-for="(item, index) in detailsList.goodsOrderRecordList"
          :key="index"
        >
          <h4>
            {{ item.statusName }}
          </h4>
          <p class="remark" v-if="item.remark">
            备注：{{ item.remark || '-' }}
          </p>
          <p>操作人：{{ item.createBy || '-' }}</p>
          <p>操作时间：{{ item.createTime | fileTime }}</p>
        </el-timeline-item>
      </el-timeline>
      <div v-else class="no_data">
        <i></i>
        <div>暂无审核记录</div>
      </div>
    </div>
    <div class="details_footer" v-if="isExamine">
      <el-button @click="returnList">取消</el-button>
      <el-button type="primary" @click="submitForm('numberValidateForm')"
        >确定</el-button
      >
    </div>
    <el-image-viewer
      v-if="showImg"
      :on-close="
        () => {
          showImg = false
        }
      "
      :url-list="[exhibitImg]"
    />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import {
  auditReimbursement,
  reimbursementDetail,
  fileUpload,
  applyReimbursement,
  entReimbursementDetail
} from '@api/orderManagement'
import { auditCancelOrder } from '@api/yardIntermediary/cancelOrder'
import { getToken } from '@utils'
export default {
  components: { ElImageViewer },
  data() {
    return {
      fileUpload,
      uploadHeader: {
        Authorization: 'Bearer ' + getToken()
      },

      validateForm: {
        cancelStatus: 2,
        cancelRemark: '',
        id: this.$route.query.id
      },
      dynamicValidateForm: {
        contractServiceStartStr: '',
        contractServiceEndStr: '',
        fileList: []
      },
      fileList1: [],
      enterpriseTime: '',
      isExamine: false,
      isRequired: false,
      activities: [],
      detailsList: {},
      roleText: '',
      isFill: false,
      applyText: '申请兑现',
      isDisabled: false,
      exhibitImg: '',
      showImg: false
    }
  },
  computed: {
    componentId() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.roleText = this.$store.state.user.userInfo.roleText

      return this.roleText
    }
  },
  filters: {
    audStatus(v) {
      let val = ''
      switch (v) {
        case 1:
          val = '待审核'
          break
        case 2:
          val = '审核通过'
          break
        case 3:
          val = '审核驳回'
          break
        default:
          break
      }
      return val
    },
    fileTime(v) {
      let branch = v.split(':')
      return branch[0] + ':' + branch[1]
    }
  },
  mounted() {
    this.reimbursement()
  },
  methods: {
    // 获取文件类型
    getUrlType(data) {
      const getSplitData = data.split('.')
      const fileType = getSplitData[getSplitData.length - 1]
      return ['png', 'jpg', 'PNG', 'jpg', 'jpeg', 'JPEG'].includes(fileType)
    },
    /** 图片预览弹窗 */
    onShow(item) {
      this.exhibitImg = item
      this.showImg = true
    },
    // time
    getPoss(val) {
      if (val) {
        this.dynamicValidateForm.contractServiceStartStr = val[0]
        this.dynamicValidateForm.contractServiceEndStr = val[1]
      } else {
        this.dynamicValidateForm.contractServiceStartStr = ''
        this.dynamicValidateForm.contractServiceEndStr = ''
      }
    },
    reimbursement() {
      let url = ''
      if (this.componentId === '机构') {
        url = entReimbursementDetail({ id: this.$route.query.id })
      } else {
        url = reimbursementDetail({ id: this.$route.query.id })
      }
      url.then(res => {
        if (res.data.code === '0000') {
          let list = res.data.data
          this.detailsList = list
          this.enterpriseTime = []
          this.enterpriseTime.push(
            list.contractServiceStartStr,
            list.contractServiceEndStr
          )
          this.dynamicValidateForm.contractServiceStartStr =
            list.contractServiceStartStr
          this.dynamicValidateForm.contractServiceEndStr =
            list.contractServiceEndStr
          if (
            this.detailsList.cancelStatus === 1 &&
            this.componentId !== '机构' &&
            this.componentId != '服务机构'
          ) {
            this.isExamine = true
          } else {
            this.isExamine = false
          }
          if (this.componentId === '机构' || this.componentId === '服务机构') {
            if (this.detailsList.cancelStatus === 0) {
              this.isFill = true
            }
            if (this.detailsList.cancelStatus === 3) {
              if (list.attachmentList.length > 0) {
                this.fileList1 = list.attachmentList.map(value => {
                  return {
                    ext: value.ext,
                    name: value.fileName,
                    ossUrl: value.ossUrl,
                    fileType: value.fileType
                  }
                })
                this.dynamicValidateForm.fileList = this.fileList1
              }

              this.applyText = '重新申请'
            } else {
              this.applyText = '申请兑现'
            }
          }
        }
      })
    },
    returnList() {
      this.$router.push({ name: 'orderList' })
    },

    adopt() {
      if (this.validateForm.cancelStatus === 3) {
        this.isRequired = true
      } else {
        this.isRequired = false
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          auditCancelOrder(this.validateForm).then(res => {
            const { code, data } = res.data
            if (code === '0000') {
              this.$message({
                message: '审核成功',
                type: 'success'
              })
              location.reload()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    apply(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let fileList2 = []

          this.dynamicValidateForm.fileList.map(f => {
            let value = ''
            if (f.response) {
              value = f.response.data
            } else {
              value = f
            }
            fileList2.push({
              ext: value.ext,
              fileName: value.fileName ? value.fileName : value.name,
              ossUrl: value.ossUrl,
              fileType: value.fileType
            })
          })

          let params = {
            id: this.validateForm.id,
            contractServiceStartStr: this.dynamicValidateForm
              .contractServiceStartStr,
            contractServiceEndStr: this.dynamicValidateForm
              .contractServiceEndStr,
            attachmentList: fileList2
          }

          applyReimbursement(params).then(res => {
            const { code, data, msg } = res.data
            if (code === '0000') {
              location.reload()
            } else {
              this.$message.error(msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 文件上传
    handleRemove1(file, fileList) {
      this.dynamicValidateForm.fileList = fileList
      // this.fileList1 = []
      // fileList.map(value => {
      //   if (value.response) {
      //     this.fileList1.push(value.response.data)
      //   } else {
      //     this.fileList1.push(value)
      //   }
      // })
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 50
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 50MB!')
      }
      return isLt2M
    },
    docSuccess1(response, file, fileList) {
      if (response.code == '0000') {
        this.dynamicValidateForm.fileList = fileList

        // this.fileList1 = []
        // fileList.map(value => {
        //   if (value.response) {
        //     this.fileList1.push(value.response.data)
        //   }
        // })
        // console.log(this.fileList1, this.dynamicValidateForm.fileList)

        this.$refs.dynamicValidateForm.validateField('fileList')
        this.isDisabled = false
      } else {
        this.$message.error(response.msg)
        fileList.pop()
        this.isDisabled = false
      }
    },
    handleProgress() {
      this.isDisabled = true
    },
    handleExceed() {
      this.$message.warning('当前限制选择 10 个文件，已上传了10个文件')
    },
    download(url) {
      // pdf 预览，其他都下载
      const urlSuffixType = url.split('.')
      const urlType = urlSuffixType[urlSuffixType.length - 1]
      const openType = ['pdf'].includes(urlType.toLowerCase())
        ? '_blank'
        : '_self'
      window.open(url, openType)
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  margin-top: 30px;
  .container_title {
    font-size: 20px;
    font-weight: 600;
  }
  .container_content {
    width: 70%;
    // min-height: 200px;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 20px 30px;
    border: 1px solid rgba($color: #000000, $alpha: 0.1);
    .voucher {
      display: flex;
      justify-content: space-between;
      padding-bottom: 10px;
      border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
      .voucher_left {
        font-size: 12px;
        color: #333;
        span {
          font-size: 16px;
          color: #999;
          margin-right: 6px;
        }
      }
      .voucher_right {
        font-size: 20px;
        // color: #f00;
        font-weight: 600;
      }
    }
    .contract {
      margin: 20px 0 30px;
      font-size: 16px;
      span {
        margin-right: 10px;
      }
    }
    .details-fill {
      margin-top: 20px;
    }
    .file_list {
      font-size: 16px;
      display: flex;
      span {
        display: inline-block;
        width: 70px;
        margin-right: 10px;
      }
      .file_box {
        // display: flex;
        // flex-wrap: wrap;
        // align-items: flex-end;
      }
      .file {
        display: inline-block;
        padding: 6px 10px;
        height: 30px;
        border-radius: 4px;
        background-color: rgb(247, 247, 247);
        cursor: pointer;
        margin-right: 20px;
        margin-bottom: 16px;
        width: auto;
        i {
          font-size: 15px;
          color: rgb(51, 153, 255);
          margin-right: 10px;
        }
      }
      img {
        width: 148px;
        height: 148px;
        border: 1px dashed #eee;
        cursor: pointer;
        margin-right: 20px;
      }
    }
  }
  .details_right {
    // overflow: hidden;
    // overflow-y: scroll;
    padding: 30px 0;
    // margin-left: 30px;
    background-color: #fff;
    border-radius: 4px;
    .histoy {
      font-size: 20px;
      margin-bottom: 20px;
      font-weight: 600;
    }
    /deep/ .el-card {
      border: none;
      box-shadow: none;
      background-color: #fff;
    }
    /deep/ .el-timeline-item__node {
      background-color: rgba(24, 144, 255, 1);
    }
    /deep/ .el-timeline-item__tail {
      height: 88%;
      margin-top: 15px;
      // border-left: 2px solid rgba(24, 144, 255, 1);
    }
    .remark {
      width: 500px;
      line-height: 22px;
      letter-spacing: 1px;
      word-wrap: break-word;
      padding-right: 10px;
    }
  }
  .demo-ruleForm {
    margin-top: 30px;
  }
  .histoy-color {
    color: #f00;
    letter-spacing: 4;
  }
  .histoy-colors {
    color: #32cd32;
    letter-spacing: 4;
  }
  .no_data {
    margin: 60px 0;
    font-size: 18px;
    color: #999;
    text-align: center;
    i {
      display: inline-block;
      width: 300px;
      height: 100px;
      background: url('../../../../assets/coupons-none.png') no-repeat;
      background-size: 100%;
      margin-bottom: 30px;
    }
  }
  /deep/.el-textarea__inner {
    resize: none;
  }
  .details_footer {
    // width: 100%;
    // position: fixed;
    // bottom: 20px;
    // left: 50%;
    // transform: translateX(1%);
    text-align: center;
    padding-bottom: 20px;
    background-color: #fff;
  }
  /deep/.el-range-separator {
    width: 20px;
  }
}
</style>
